import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const ModalSectionWrapper = ({ children, wrapperSx = {}, testId = 'modal-section-wrapper' }) => {
    return (
        <Box
            sx={{
                paddingTop: '1rem',
                width: '100%',
                ...wrapperSx,
            }}
            data-testid={testId}
        >
            {children}
        </Box>
    );
};

ModalSectionWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    wrapperSx: PropTypes.object,
    testId: PropTypes.string,
};

ModalSectionWrapper.defaultProps = {
    wrapperSx: {},
    testId: 'modal-section-wrapper',
};

export default ModalSectionWrapper;
